import styled from "styled-components";

export const StyledMobileNavBar = styled.div`
  position: fixed;
  z-index: 90;
  bottom: 0;
  left: 0;
  height: calc(66px + env(safe-area-inset-bottom));
  width: 100%;

  svg {
    width: 22px;
    height: 22px;
    color: currentColor;
  }

  .line-icon path {
    fill: none;
    stroke: currentColor;
    stroke-width: 2.35;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .buttons-container {
    padding: 7px 10px calc(7px + env(safe-area-inset-bottom));
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    align-items: center;
    justify-items: center;
    gap: 6px;
    height: 100%;
    color: rgb(255, 255, 255);
    background: rgba(10, 31, 39, 0.97);
    border-top: 1px solid rgba(89, 244, 119, 0.12);
    box-shadow: 0 -14px 34px rgba(0, 0, 0, 0.26);
    backdrop-filter: blur(12px);
  }

  button {
    margin: 0 !important;
  }

  .button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    transition:
      color 160ms ease,
      background 160ms ease,
      border-color 160ms ease,
      transform 160ms ease,
      box-shadow 160ms ease;
    appearance: none;
    border: 1px solid transparent;
    letter-spacing: 0;
    cursor: pointer;
    user-select: none;
    width: 46px;
    height: 46px;
    min-width: 46px;
    border-radius: 14px;
    font-family: "GmarketSans", "Noto Sans KR", sans-serif;
    font-weight: 800;
    font-style: normal;
    font-size: 0;
    text-decoration: none;
    color: #c2d0dc;
    background: transparent;
    padding: 0;

    &.MuiButton-root {
      min-width: 46px;
      padding: 0;
      border-radius: 14px;
      font-size: 0;
      color: #c2d0dc;
      background: transparent;
    }

    &:hover {
      color: #f5fbff;
      background: rgba(166, 196, 213, 0.08);
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0) scale(0.97);
    }

    &.is-active {
      color: var(--crypto-green);
      border-color: rgba(89, 244, 119, 0.24);
      background: rgba(89, 244, 119, 0.09);
    }
  }

  .mobile-nav-home {
    width: 52px;
    height: 52px;
    min-width: 52px;
    border-radius: 18px;
    color: #07130d;
    background: linear-gradient(180deg, #59f477 0%, #27d963 100%);
    box-shadow: 0 12px 30px rgba(39, 217, 99, 0.2);

    svg {
      width: 24px;
      height: 24px;
    }

    &:hover,
    &.is-active {
      color: #07130d;
      background: linear-gradient(180deg, #66fb84 0%, #27d963 100%);
      border-color: transparent;
    }
  }

  .mobile-nav-placeholder {
    pointer-events: none;
    opacity: 0;
  }

  @media (max-width: 380px) {
    .buttons-container {
      padding-inline: 7px;
      gap: 3px;
    }

    .button {
      width: 42px;
      height: 42px;
      min-width: 42px;
      border-radius: 12px;
    }

    .mobile-nav-home {
      width: 48px;
      height: 48px;
      min-width: 48px;
    }
  }
`;
